import { useEffect, useState, useRef } from "react";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import posService from "../../services/pos/pos.service";
import RawMaterialService from "../../services/RawMaterials/RawMaterialService";

interface AddRawMaterialstoposProps {
  posId: number;
  onSuccess?: () => void; 
}

const AddRawMaterialstopos: React.FC<AddRawMaterialstoposProps> = ({ posId, onSuccess }) => {

  const toast = useRef<Toast>(null);
  const [Rawmaterials, setRawmaterials] = useState<any[]>([]);
  const [selectedRawmaterials, setselectedRawmaterials] = useState<any | null>(null);
  const [safetyStock, setSafetyStock] = useState<number>(0);
  const [reorderStock, setReorderStock] = useState<number>(0);
  const [RawmaterialsLoaded, setRawmaterialsLoaded] = useState(false);

   const handleRawMaterialChange = (e: DropdownChangeEvent) => {
    setselectedRawmaterials(e.value);
  };

  const handleDropdownShow = () => {

  if (posId && !RawmaterialsLoaded) {
    RawMaterialService.GetRemainingposRawMaterials(posId)
      .then((res: any[]) => {
        setRawmaterials(res || []);
        setRawmaterialsLoaded(true); // to avoid reloading
      })
      .catch(() =>
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to load products",
        })
      );
  }
};

  const handleAddRawmaterials = async () => {
    if (!selectedRawmaterials || safetyStock < 0 || reorderStock < 0) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Select a Product",
      });
      return;
    }
    const payload = {
      rawMaterialId: selectedRawmaterials.rawMaterialId,
      measurementTypeId: selectedRawmaterials.measurementTypeId,
      posId,
      safetyStock,
      reorderStock,
    };

    try {
      const res = await RawMaterialService.AddposRawmaterials(payload);
      if (res?.isSuccess) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Raw Materials added successfully",
        });
        if (onSuccess) onSuccess(); 
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: res?.message || "Failed to add Raw Materials",
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "An error occurred while adding the product",
      });
    }
  };

  return (
    <div className="p-fluid">
      <Toast ref={toast} />
      <h4 className="mb-3">Add RawMaterials to POS</h4>

      <Dropdown
        value={selectedRawmaterials}
        options={Rawmaterials}
        onChange={handleRawMaterialChange}
        onShow={handleDropdownShow} // Load when opened
        filter
        optionLabel="rawMaterialName"
        placeholder="Select Raw Material"
        className="mb-3"
        style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
      />

      <InputText
        placeholder="Safety Stock"
        type="number"
        min="0"
        keyfilter="pnum"
        onChange={(e) => setSafetyStock(Number(e.target.value))}
        className="mb-3"
        style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
      />

      <InputText
        placeholder="Reorder Stock"
        type="number"
        min="0"
        keyfilter="pnum"
        onChange={(e) => setReorderStock(Number(e.target.value))}
        className="mb-3"
        style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
      />

      <Button label="Add Raw material" onClick={handleAddRawmaterials} />
    </div>
  );
};

export default AddRawMaterialstopos;
